import { IconContainer } from "./VendorIcon.styles";
import { IconFillColorProps } from "@component/Icons/Icon";
import { ReactComponent as RooamIcon } from "../../assets/icon.svg";

export default function VendorRewardsIcon(
  _props: IconFillColorProps
): React.ReactElement {
  return (
    <IconContainer>
      <RooamIcon />
    </IconContainer>
  );
}
